import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { API_BASE_URL } from '../../environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDatepickerInputEvent }   from '@angular/material';
import { PageEvent } from '@angular/material/paginator';
import { OperationDialogComponent } from './operation-dialog/operation-dialog.component';
import { ExchangeDialogComponent } from './exchange-dialog/exchange-dialog.component';
import { ExchangeEditDialogComponent } from './exchange-edit-dialog/exchange-edit-dialog.component';
import { HolidayDialogComponent } from './holiday-dialog/holiday-dialog.component';
import { DataConfirmDialogComponent } from './data-confirm-dialog/data-confirm-dialog.component';
import * as XLSX from 'xlsx';
import moment from 'moment';
import { BaseComponent } from '../base.component';
import { StaffDetailDialogComponent } from '../staffs/staff-detail-dialog/staff-detail-dialog.component';
import { HOLDAY_TYPE } from '../operation/holiday-dialog/holiday-dialog.component';
import { getAreaSession } from '../common/utils';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MobileZoomService } from '../common/mobile-zoom/mobile-zoom.service';

// 区分（祝日・全社祝日・ゴミ・時間指定）の1区切り。期間中ずっと同じなら period は空
interface FlagSegment { text: string; period: string; }

@Component({
  selector: 'app-operation',
  templateUrl: './operation.component.html',
  styleUrls: ['./operation.component.less']
})

export class OperationComponent extends BaseComponent implements OnInit, OnDestroy {

  // ローディング中
  nowLoading = true;

  // エクスポート用ローディング
  loadingExport = false;

  // データ
  list = [];

  // 総件数
  totalSize = 0;

  // 1ページの件数
  pageSize = 50;

  // ページ数
  pageIndex = 0;

  // 清掃員検索
  filterName = "";

  // 清掃員カナ検索
  filterNameKana = "";

  // 清掃員コード
  filterStaffCd = null;

  // TEL検索
  filterTel = "";

  // URLに含まれているTEL
  filterTel2 = "";

  // エリアリスト
  areas = [];

  // エリア検索
  areaIds = [];

  // 物件名検索
  filterSiteName = "";

  // 手配あり検索
  arranged = true;

  // 要手配検索
  arrangement = false;

  // 期間開始日
  startDay = new FormControl(new Date());

  // 期間終了日
  endDay = new FormControl(new Date(moment().add(6, 'days').format('YYYY-MM-DD')));

  // 代勤種別検索選択肢
  statusChoices = [
    {key: 'all', value: '全て', text: '全て', color: 'drop-all'},
    {key: 'unknown', value: '未登録', text: '未登録', color: 'drop-unknown'},
    {key: 'alreadyRegistered', value: '登録済み', text: '代勤確定', color: 'drop-alreadyRegistered'}, // 文言変更（登録済み➡代勤確定）2025-05
    {key: 'ok', value: '●：代勤OK', text: '●：前日確認OK', color: 'drop-ok'}, // 文言変更（代勤OK➡●：前日確認OK）2025-05
    {key: 'ng', value: '×：代勤行けない', text: '×：代勤行けない', color: 'drop-ng'},
    {key: 'noContact', value: '×：連絡とれず', text: '×：連絡とれず', color: 'drop-ngContact'},
    {key: 'request', value: '復帰確認', text: '復帰確認', color: 'drop-request'},
    {key: 'cantReturn', value: '復帰不可・連絡取れず', text: '復帰不可・連絡取れず', color: 'drop-cantReturn'},
    {key: 'holiday', value: '休み取り消し', text: '休み取り消し', color: 'drop-holiday'},
    {key: 'arrangement', value: '要手配', text: '要手配', color: ''}
  ];

  // 休み登録検索値
  status = this.statusChoices[0]['value'];

  // ソート検索選択肢
  sortChoices = [
    {key: 'cdSite', value: '物件'},
    {key: 'staff', value: '清掃員'}
  ];

  // ソート値
  sort = this.sortChoices[0]['key'];

  // 勤務時間表示
  showShift: boolean = true;

  // 「範囲指定」チェックボックス
  rangeSpecified: boolean = false;

  // 日付カラム
  days = [
    { holidays: '', day: '' }
  ];

  headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  @ViewChild('TABLE') table: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private router: Router,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    public mz: MobileZoomService)  {
    super();
  }

  async ngOnInit() {
    // スマホ：PC と同じ見た目を縮めて出す（MobileZoomService）。この画面だけピンチで拡大させない（マスのメニューの位置がずれるため）
    this.mz.enter({ noPinch: true });

    // ユーザー設定 手配あり
    this.arranged = (localStorage.getItem('operationArrangement') == 'true');

    let arrangedCheck = this.route.snapshot.paramMap.get('hasHoliday');
    // 「有休5日使用義務」から遷移した場合は、手配ありのチェックを外す
    if (arrangedCheck == 'false') {
      this.arranged = false;
    // RP の確認メインタスクから遷移した場合（operations/true/開始日/終了日/清掃員コード）は、手配ありで開く
    } else if (arrangedCheck == 'true') {
      this.arranged = true;
    // 電話番号の場合
    } else if (arrangedCheck) {
      this.filterTel2 = arrangedCheck;
      this.arranged = false;
    }

    // パラメータに開始日、終了日あり
    const start = this.route.snapshot.paramMap.get('start');
    const end = this.route.snapshot.paramMap.get('end');
    if (start) this.startDay = new FormControl(new Date(start));
    if (end) this.endDay = new FormControl(new Date(end));

    this.getLocalStarge();

    // ユーザー設定 エリア検索あり
    let userArea = JSON.parse(localStorage.getItem('filterArea') || 'null');

    // パラメータに清掃員コードあり（前回の検索条件より優先する）
    // 前回の検索条件が残っていると、条件が重なって目的の清掃員が出ないので、ほかの検索条件は空にして開く
    const staffCd = this.route.snapshot.paramMap.get('staffCd');
    if (staffCd && !isNaN(Number(staffCd))) {
      this.filterStaffCd = staffCd;
      this.filterName = '';
      this.filterNameKana = '';
      this.filterTel = '';
      this.filterSiteName = '';
      userArea = null;
    }

    // パラメータに物件名あり（月次確認の時間差分から。?siteName=）
    // 清掃員コードのときと同じく、ほかの検索条件は空にして開く
    const siteName = this.route.snapshot.queryParamMap.get('siteName');
    if (siteName) {
      this.filterSiteName = siteName;
      this.filterName = '';
      this.filterNameKana = '';
      this.filterTel = '';
      this.filterStaffCd = null;
      userArea = null;
    }

    await this.getAreas(userArea);
    this.getOperations();
  }

  /**
   * ほかの画面へ移るときは viewport を元に戻す
   */
  ngOnDestroy() {
    this.mz.leave();
  }

  /**
   * 最初のページにしてデータ再取得
   */
  applyFilter() {
    this.pageIndex = 0;
    this.getOperations();
  }

  /**
   * 「手配あり」のチェック変更。両方 ON だと意味が矛盾するので、ON にしたら「要手配」を外す
   */
  changeArranged() {
    if (this.arranged) {
      this.arrangement = false;
    }
    this.applyFilter();
  }

  /**
   * 「要手配」のチェック変更。ON にしたら「手配あり」を外す
   */
  changeArrangement() {
    if (this.arrangement) {
      this.arranged = false;
    }
    this.applyFilter();
  }

  /**
   * エリア検索
   * @param opened 選択肢OPEN
   */
  onAreaSelectOpened(opened: boolean) {
    // 閉じた瞬間だけ検索
    if (!opened) {
      this.applyFilter()
    }
  }

  /**
   * ページ変更
   * @param event
   */
  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.list = []
    this.getOperations();
  }

  /**
   * 表示期間（YYYY-MM-DD）。日付として正しくない、または開始日が終了日より後なら null（そのときは何もしない）
   */
  period(): { start: string, end: string } | null {
    const s = moment(this.startDay.value);
    const e = moment(this.endDay.value);
    if (!this.startDay.value || !this.endDay.value || !s.isValid() || !e.isValid()) return null;

    const start = s.format('YYYY-MM-DD');
    const end = e.format('YYYY-MM-DD');
    if (start > end) return null;

    return { start, end };
  }

  /**
   * 稼働管理の取得URL
   * @param index ページ数
   * @param size 1ページの件数（0 なら全件）
   * @param start 表示開始日
   * @param end 表示終了日
   */
  operationUrl(index: number, size: number, start: string, end: string): string {
    // 清掃員コード検索項目nullはゼロに変換
    let filterStaffCd = this.filterStaffCd
    if (!filterStaffCd || isNaN(this.filterStaffCd)) {
      filterStaffCd = 0
    }

    return API_BASE_URL + '/api/v1/contractDetail/operationManagement?s=0&e=8000&index=' + index
            + "&size=" + size
            + "&filterName=" + encodeURIComponent(this.filterName)
            + "&filterNameKana=" + encodeURIComponent(this.filterNameKana)
            + "&filterStaffCd=" + filterStaffCd
            + "&filterTel=" + encodeURIComponent(this.filterTel)
            + "&filterTel2=" + encodeURIComponent(this.filterTel2)
            + "&filterSiteName=" + encodeURIComponent(this.filterSiteName)
            + "&areaIds=" + this.areaIds
            + "&startDate=" + start
            + "&endDate=" + end
            + "&status=" + this.status
            + "&arranged=" + this.arranged
            + "&sort=" + this.sort
            + "&arrangement=" + this.arrangement;
  }

  /**
    * 稼働予定一覧を取得します
    */
  getOperations() {
    // 日付がまともに入っているときだけ取得する
    const period = this.period();
    if (!period) return;

    this.nowLoading = true;

    this.http.get(
      this.operationUrl(this.pageIndex, this.pageSize, period.start, period.end),
      {headers: this.headers}
    )
    .subscribe(res => {
      if (res) {
        // 表示期間の日付配列を生成
        const daysList = this.getDaysList(period.start, period.end);
        // 日付部分のカラム生成
        this.days = this.setDays(res, daysList);
        this.setListData(res as [], daysList.list);
        // データ一覧生成
        this.list = res as []
      }
      this.nowLoading = false;

      // ローカルストレージにセット
      this.setLocalStarge();
    },
    () => {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      this.nowLoading = false;
    });
  }

  /**
   * 表示期間の日付配列を生成
   * @param start
   * @param end
   */
  getDaysList(start: string, end: string): {list: string[], column: string[]} {
    moment.locale('ja');
    const list: string[] = [];
    const column: string[] = [];
    // 開始日
    let day = moment(new Date(start))
    // 開始日から終了日までの日付配列
    while (day.format('YYYY-MM-DD') <= end) {
      // キー用
      list.push(day.format('YYYY-MM-DD'));
      // カラム用
      column.push(day.format('YYYY/M/D') + '(' + day.format('dd') + ')')
      day = day.add(1, 'day');
    }
    return { list, column };
  }

  /**
   * 日付カラム生成、総件数セット
   * @param data 取得したデータ
   * @param daysList 日付配列
   */
  setDays (data, daysList: {list: string[], column: string[]}) {
    const res = []
    if (data && data.length) {
      const row = data[0]
      this.totalSize = row.totalSize
    } else {
      this.totalSize = 0
    }

    for (let i = 0; i < daysList.list.length; i++) {
      const day = daysList.list[i];

      let ho = 0
      let pa = 0
      let va = 0

      // うち振替（休み・有休・欠員の件数には振替も入っている。内訳として「（振n）」で出す）
      let hoEx = 0
      let paEx = 0
      let vaEx = 0

      let total = 0

      // 日ごとの件数はどの行にも同じ値が入っているので、1行目の日ごとのデータ（days）から取る
      if (data && data[0] && data[0].days && data[0].days[day]) {
        const d = data[0].days[day]

        ho = d.holidayCount || 0
        pa = d.paidCount || 0
        va = d.ketsuinCount || 0

        hoEx = d.holidayExchangeCount || 0
        paEx = d.paidExchangeCount || 0
        vaEx = d.ketsuinExchangeCount || 0

        total = ho + pa + va
      }

      // 振替があるときだけ「（振n）」を付ける
      const ex = (n: number) => n > 0 ? `(振${n})` : ''

      res.push({ day, column: daysList.column[i], holiday: `休${ho}${ex(hoEx)}/有${pa}${ex(paEx)}/欠${va}${ex(vaEx)}/計${total}` })
    }

    return res
  }

  /**
   * 休み登録の帯を生成
   * @param list 一覧
   * @param daysList 日付配列
   * @returns
   */
  setListData(list: any[], daysList: any[]) {
    if (list && list.length) {


      for (let i = 0; i < list.length; i++) {
        const row = list[i];

        // 祝日・全社祝日・ゴミ・時間指定（契約は日によって値が変わることがあるので、変わる日を付けて並べる）
        // 欠員物件・時間数不足の行（清掃員コード -1）には雇用指示が無いので、雇用側は出さない
        const noStaff = String(row.staffDailyCleaning) == '-1'
        row.flags = {
          holidayContract: this.flagSegments(row.days, daysList, 'holidayContract'),
          companysContract: this.flagSegments(row.days, daysList, 'companysContract'),
          garbageContract: this.flagSegments(row.days, daysList, 'garbageContract'),
          specificTime: this.flagSegments(row.days, daysList, 'specificTime'),
          holidayEmp: noStaff ? [] : this.flagSegments(row.days, daysList, 'holidayEmp'),
          companysEmp: noStaff ? [] : this.flagSegments(row.days, daysList, 'companysEmp'),
          garbageEmp: noStaff ? [] : this.flagSegments(row.days, daysList, 'garbageEmp')
        }

        // 同じ休みの場合帯状にするため、いくつ続いているかカウント（先頭の休みのみに表示）
        let holidayWidth = 0
        let status = null
        let headHoliday = null

        for (let j = 0; j < daysList.length; j++) {
          const day = daysList[j];

          if (row.days[day]) {
            // 休み登録がなくて、振替指定日になっている場合は振替指定日を表示（休み登録されている場合は、休み登録が優先表示）
            if (row.days[day].exchangeTimesText) {
              row.days[day].exchangeTimesText = row.days[day].exchangeTimesText.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');

              if (!row.days[day].status || row.days[day].deleteHoliday) {
                row.days[day].status = row.days[day].exchangeTimesText
              }
            }
            // 欠員物件・時間数不足の行：本来表示されない行に回されてきた振替先の時間（「+3.0000」→「+3」。帯にはしない）
            if (row.days[day].hiddenExchangeText) {
              row.days[day].hiddenExchangeText = row.days[day].hiddenExchangeText.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
            }
          }

          // 休み登録ありOR振替指定日OR自動欠員表示
          if (row.days[day] && (row.days[day].status || row.days[day].isKetsuin)) {
            row.days[day].fillColor = this.fillColor(row.days[day], row)

            // 時間数不足で見せかけの欠員の場合
            let shortage = ''
            if (row.days[day].isKetsuin) {
              shortage = '2' // 欠員の番号
            }

            // 前日と同じ
            if (status == (row.days[day].status || shortage)) {
              // ＋カウント
              holidayWidth++
              // 前日のと同じため、0にする
              row.days[day].holidayWidth = 0

            // 前日と違う
            } else {
              if (headHoliday) this.setHolidayColor(row.days, headHoliday, holidayWidth, status, shortage)

              // カウント開始
              holidayWidth = 1
              status = row.days[day].status || shortage
              headHoliday = day
            }

            // 最後の行
            if (j == daysList.length - 1) {
              if (headHoliday) this.setHolidayColor(row.days, headHoliday, holidayWidth, status, shortage)
            }

          // 休み登録なし＆振替指定日なし＆自動欠員無し
          } else {
            if (headHoliday) this.setHolidayColor(row.days, headHoliday, holidayWidth, status, null)

            // リセット
            holidayWidth = 0
            status = null
            headHoliday = null
            if (row.days[day]) {
              row.days[day].holidayWidth = 0;
            }
          }
        }
      }
    }
    return list
  }

  /**
   * 区分（祝日・全社祝日・ゴミ・時間指定）を、値が変わる日で区切って並べる
   * 期間中ずっと同じ値なら1つだけ（期間なし）。値が変わるなら「値（〜M/D）」「値（M/D〜M/D）」「値（M/D〜）」の並び
   * 値が無い日（契約の行が効いていない日など）は飛ばす
   * @param days 行の日ごとのデータ
   * @param daysList 表示期間の日付（YYYY-MM-DD の昇順）
   * @param key 区分のキー
   * @returns [{ text: 区分名, period: 期間の文字（1つだけなら空） }]
   */
  flagSegments(days: any, daysList: string[], key: string): FlagSegment[] {
    const segments: { text: string, start: string, end: string }[] = []
    if (!days) return []

    for (const day of daysList) {
      const value = days[day] ? days[day][key] : null
      if (value === null || value === undefined || value === '') continue

      const last = segments[segments.length - 1]
      if (last && last.text === value) {
        last.end = day
      } else {
        segments.push({ text: value, start: day, end: day })
      }
    }

    // 期間中ずっと同じなら期間は付けない
    if (segments.length <= 1) {
      return segments.map(s => ({ text: s.text, period: '' }))
    }

    const md = (d: string) => moment(d).format('M/D')
    return segments.map((s, i) => {
      let period = ''
      if (i === 0) {
        period = '〜' + md(s.end)
      } else if (i === segments.length - 1) {
        period = md(s.start) + '〜'
      } else {
        period = md(s.start) + '〜' + md(s.end)
      }
      return { text: s.text, period }
    })
  }

  /**
   * 休み登録の帯を生成
   * @param row 対象行
   * @param headHoliday 休み登録先頭日
   * @param holidayWidth 休みの連続数
   * @param status 種別
   * @param shortage 自動欠員がある場合は「2」
   */
  setHolidayColor(row: any, headHoliday: string, holidayWidth: number, status: string, shortage: String) {
    if (!row || !row[headHoliday]) {
      console.log(row)
    }
    // 帯の色
    let color = ''
    // 連続数
    row[headHoliday].holidayWidth = holidayWidth * 124 + holidayWidth + (Math.floor(holidayWidth / 2) * 4)

    // 種別名
    if (status && status.indexOf('+') > -1) {
      // 振替指定日
      row[headHoliday].statusName = '振替指定日'

    } else if (status) {
      // 休み登録
      const name = HOLDAY_TYPE.find((h) => { return status == String(h.key) })
      row[headHoliday].statusName = name ? name.val : '不明'
    }

    // 自動欠員があり、休み登録なし、休み削除は無視
    if (shortage == '2' && !status) {
      // 自動欠員
      row[headHoliday].statusName = '欠員'
      color = 'orange-band'
    }

    if (status == '2') {
      // 欠員はオレンジ
      color = 'orange-band'
    } else if (status == '5') {
      // 要確認は紫
      color = 'purple-band'
    } else if (status) {
      color = 'red-band'
    }

    row[headHoliday].holidayColor = color
  }

  /**
   * セルの背景色
   */
  fillColor(tar, row) {
    // 休み登録
    const absence = tar.status

    // 見せかけの欠員（もともと人が足りない所）
    if (tar.isKetsuin) {
      return "notAssigned";
    }

    // 振替先の日の不足（回されてきた時間がこの行の確定代勤で埋まっておらず、物件の合計もマイナス）。手配が要る印として黄色
    if (tar.isExchangeShort) {
      return "notAssigned";
    }

    // 振替元：この行の確定代勤＋回した時間がその日の雇用時間に足りず、物件の合計もマイナスなら橙、そうでなければ青
    // （前は物件の確定の累計で決めていて、自分は足りていても別の契約の不足で橙になることがあった）
    if (absence && ['7', '9', '10', '11'].includes(absence)) {
      return tar.isExchangeOriginShort ? "notAssigned" : "ok";
    }

    // 通常清掃員が休み登録している
    if (absence) {
      // もともと休みの日に休み登録している
      if (!tar.workingTime || tar.workingTime == '-' || row.cdSite == '000000000' || row.isShow == '0') {
        return '';
      }
      return "notAssigned";
    }
    return null;
  }

  /**
   * 代勤セルに色付け
   * ●：代勤OK は、その行がその日に時間の要手配（バックの is_arrange_hours。①黄色の行で確定が足りない ②休み登録の行 ③振替先 ④振替元）ならピンク、そうでなければ青
   * （⑤初出勤の引継ぎの有無（is_arrange にだけ入る）では色を変えない。引継ぎが無いことはマスの「初出勤日」と要手配 ☑ で分かる）
   * （前は物件の確定の累計で決めていて、別の契約の休みの分でピンクになることがあった）
   * @param status 代勤
   * @param isArrange その行・その日が時間の要手配か
   * @returns
   */
  workInsteadColor(status: string, isArrange: boolean) {
    switch(status) {
      case '未登録': return "drop-unknown";
      case '登録済み': return "drop-alreadyRegistered";
      case '●：代勤OK':
        if (isArrange) {
          return "drop-unknown";
        } else {
          return "drop-ok";
        }
      case '×：代勤行けない': return "drop-ng";
      case '×：連絡とれず'  : return "drop-ngContact";
      case '復帰確認': return "drop-request";
      case '復帰不可・連絡取れず': return "drop-cantReturn";
      case '休み取り消し': return "drop-holiday";
      case 'スポット作業': return "spot";
    }
  }

  /**
   * エリアドロップダウン作成
   * @param userArea 個人設定されているユーザー用のエリア
   */
  async getAreas(userArea) {
    const area = getAreaSession()

    if (area && area.length) {
      this.areas = area
    } else {
      try {
        const res = await this.http.get(
          API_BASE_URL + "/api/v1/area?type=1",
          { headers: this.headers }
        ).toPromise();

        this.areas = res as any[];

      } catch (e) {
        alert("エラーが発生しました");
        this.router.navigate(['/']);
      }
    }

    if (userArea && Array.isArray(userArea) && this.areas && this.areas.length) {
      // areas に存在する areaId のみ残す
      const areaIdSet = new Set(this.areas.map(a => a.areaId));
      this.areaIds = userArea.filter(id => areaIdSet.has(id));
    }
  }

  /**
   * 休み削除
   */
  removeHoliday(httpOptions: { headers: HttpHeaders }, param: any, time: string) {
    // 物件名・清掃員名・時間帯は、ログと休み削除のメールに使う
    this.http.post(
      API_BASE_URL + "/api/v1/status/remove?nameSite=" + encodeURIComponent(String(param.nameSite || '').replace(/\r?\n/g, ' '))
        + "&name=" + encodeURIComponent(param.nameStaff || '')
        + "&time=" + encodeURIComponent(time || ''),
      [param], httpOptions
    ).subscribe(() => {
      this.getOperations();
    },(error) => {
      // 7連勤になるなど、削除できない理由があるとき
      if (error && error.error && error.error.status == 801) {
        alert(error.error.message);
        return;
      }
      if (error && (error.status == 401 || error.status == 403)) {
        alert("認証に失敗しました");
        this.router.navigate(['/']);
        return;
      }
      alert("休みを削除できませんでした。");
    });
  }

  /**
   * 休み削除処理の確認（1日分）
   * @param row 対象行
   * @param day 日付
   */
  removeConfirm(row: any, day: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        "X-LoginAccessKey": localStorage.getItem("accessKey")
      })
    };
    const param = {
      sequenceNumber: row.sequenceNumber,
      cdSite: row.cdSite,
      staffDailyCleaning: row.staffDailyCleaning,
      day,
      nameSite: row.nameSite,
      nameStaff: row.nameStaff
    };

    let name = ''
    if (row.nameStaff) {
      name = row.nameStaff.replaceAll(/\s+/g, '') + 'さんの'
    }

    if (window.confirm(name + day + 'の休みを削除してよろしいでしょうか？')) {
      // 休み削除（時間帯はログとメールに使う。「13:00 - 16:00\n作業開始」のような印の行は付けない）
      const time = row.days && row.days[day] ? String(row.days[day].workingTime || '').split('\n')[0].trim() : '';
      this.removeHoliday(httpOptions, param, time);
    }
  }

  /**
   * 表示開始日
   * @param event
   */
  changeStartDate(event: MatDatepickerInputEvent<Date>) {
    this.startDay = new FormControl(event.value);
    // 範囲指定なし
    if (!this.rangeSpecified) {
      const end =  moment(this.startDay.value).add(6, 'days');
      this.endDay = new FormControl(end);
    }
    this.applyFilter();
  }

  /**
   * 表示終了日
   * @param event
   */
  changeEndDate(event: MatDatepickerInputEvent<Date>) {
    this.endDay = new FormControl(event.value);
    this.applyFilter();
  }

  /**
   * 表示開始日・終了日を一緒に n 日ずらす（期間の長さはそのまま）。「◀」「▶」ボタン
   * @param n ずらす日数（-1：1日前へ、1：1日後へ）
   */
  shiftDays(n: number) {
    const s = moment(this.startDay.value);
    const e = moment(this.endDay.value);
    if (!s.isValid() || !e.isValid()) return;

    this.startDay = new FormControl(s.add(n, 'days').toDate());
    this.endDay = new FormControl(e.add(n, 'days').toDate());
    this.applyFilter();
  }

  // ------------------------------------------------------------
  // エクスポート
  // ------------------------------------------------------------

  /**
   * エクスポートボタンイベント
   * 今の検索条件で全ページ分を取り直し、Excel（1シート）に出す
   */
  async exportBtn() {
    const period = this.period();
    if (!period) return;

    this.loadingExport = true;
    try {
      // size=0 でバックが LIMIT を付けずに全件返す
      const res = await this.http.get(
        this.operationUrl(0, 0, period.start, period.end),
        {headers: this.headers}
      ).toPromise() as any[];

      const daysList = this.getDaysList(period.start, period.end);
      const list = res || [];
      // 画面と同じ加工（振替指定日の文字・区分の並び）を通す
      this.setListData(list, daysList.list);

      this.export(this.exportRows(list, daysList), period);

    } catch (e) {
      console.log(e)
      alert("エクスポートに失敗しました");
    } finally {
      this.loadingExport = false;
    }
  }

  /**
   * Excel に出す行（2次元配列）を作る
   * 1行目：見出し、2行目：日ごとの件数、3行目から：1行＝1つの雇用指示（画面の1行）
   * @param list 全件のデータ
   * @param daysList 表示期間の日付
   */
  exportRows(list: any[], daysList: {list: string[], column: string[]}): any[][] {
    const rows: any[][] = []

    // 見出し
    const head = ['現場名', '物件コード', '契約コード', '通常清掃員', '清掃員コード', '携帯TEL', '固定TEL']
    for (const column of daysList.column) head.push(column)
    head.push('祝日', '全社祝日', 'ゴミ', '時間指定')
    rows.push(head)

    // 日ごとの件数（画面の見出しと同じ）
    const days = this.setDays(list, daysList)
    const count = ['', '', '', '', '', '', '']
    for (const d of days) count.push(d.holiday)
    count.push('', '', '', '')
    rows.push(count)

    for (const row of list) {
      const noStaff = String(row.staffDailyCleaning) == '-1'
      const line: any[] = [
        row.nameSite || '',
        row.cdSite || '',
        row.cdContract || '',
        (row.isShow == '0' ? '（本来表示されません）' : '') + (row.nameStaff || ''),
        noStaff ? '' : (row.staffDailyCleaning || ''),
        row.mobile || '',
        row.phone || ''
      ]
      for (const day of daysList.list) {
        line.push(this.exportDayText(row, row.days ? row.days[day] : null))
      }
      line.push(
        this.exportFlagText(row.flags.holidayContract, row.flags.holidayEmp),
        this.exportFlagText(row.flags.companysContract, row.flags.companysEmp),
        this.exportFlagText(row.flags.garbageContract, row.flags.garbageEmp),
        this.exportFlagText(row.flags.specificTime, [])
      )
      rows.push(line)
    }
    return rows
  }

  /**
   * Excel の日のセルの文字（画面のセルに出ているものを改行で並べる）
   * 時間帯、休み登録／振替指定日／欠員、不足時間、代勤（1人1行）、メモ
   * @param row 行
   * @param d その日のデータ
   */
  exportDayText(row: any, d: any): string {
    if (!d) return '-'
    const lines: string[] = []

    // 時間帯（「作業開始」などの改行付きの文字を含む）
    lines.push(d.workingTime || '-')

    // 欠員物件・時間数不足の行：本来表示されません行に回されてきた振替先の時間（画面のマスと同じ「（+3ｈ 振替）」。「○h不足」にこの分が入っている理由が分かるように）
    if (d.hiddenExchangeText) {
      lines.push('（' + d.hiddenExchangeText + 'ｈ 振替）')
    }

    // 休み登録（振替指定日は setListData で status に「+○」が入っている）
    if (d.status && String(d.status).indexOf('+') > -1) {
      lines.push('振替指定日（' + d.status + 'ｈ）')
    } else if (d.status) {
      const name = HOLDAY_TYPE.find((h) => { return d.status == String(h.key) })
      lines.push(name ? name.val : '不明')
    } else if (d.isKetsuin) {
      lines.push('欠員')
    }

    // 欠員物件・時間数不足の行の不足時間
    if (String(row.staffDailyCleaning) == '-1' && d.kariDiffCumulative < 0) {
      lines.push((Math.round(d.kariDiffCumulative * -100) / 100) + 'h不足')
    }

    // 代勤
    for (const op of d.op || []) {
      lines.push('【代】' + [op.startEndTime, op.workInstead, op.status, op.phone].filter(x => x).join(' '))
    }

    // メモ
    if (d.note) {
      lines.push('メモ：' + d.note)
    }

    return lines.join('\n')
  }

  /**
   * Excel の区分（祝日・全社祝日・ゴミ・時間指定）の文字。「契約：なし（〜9/30）／あり（10/1〜）」と「雇用：…」を改行で並べる
   * @param contract 契約側の区切り
   * @param emp 雇用側の区切り（時間指定は無し）
   */
  exportFlagText(contract: FlagSegment[], emp: FlagSegment[]): string {
    const join = (segments: FlagSegment[]) => segments.map(s => s.text + (s.period ? '（' + s.period + '）' : '')).join('／')
    const lines: string[] = []
    if (contract && contract.length) lines.push('契約：' + join(contract))
    if (emp && emp.length) lines.push('雇用：' + join(emp))
    return lines.join('\n')
  }

  /**
   * エクスポート実行
   * @param rows 2次元配列（1行目が見出し）
   * @param period 表示期間（ファイル名に使う）
   */
  export(rows: any[][], period: { start: string, end: string }) {
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(rows);

    // 列幅（文字数の目安）。現場名・清掃員・日のセルは広め
    const cols: { wch: number }[] = [
      { wch: 30 }, { wch: 11 }, { wch: 9 }, { wch: 18 }, { wch: 10 }, { wch: 14 }, { wch: 14 }
    ]
    const dayCount = rows[0].length - cols.length - 4
    for (let i = 0; i < dayCount; i++) cols.push({ wch: 24 })
    cols.push({ wch: 18 }, { wch: 18 }, { wch: 18 }, { wch: 14 })
    ws['!cols'] = cols;

    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '稼働管理');

    /* save to file */
    XLSX.writeFile(wb, '稼働管理_' + period.start + '_' + period.end + '.xlsx');
  }

  // ------------------------------------------------------------
  // 画面の部品
  // ------------------------------------------------------------

  /**
   * スポット登録権限
   */
  getSpotAuth() {
    return localStorage.getItem("spot");
  }

  /**
   * 休み削除権限（ユーザ管理の「休み削除」。メニューの「休み削除」を出すかどうか）
   */
  getDeleteHolidayAuth() {
    return localStorage.getItem("deleteHoliday");
  }

  /**
   * 電話リンク（tel:）。記号を除いた数字だけにする
   * @param tel 電話番号
   */
  telHref(tel: string): string {
    return 'tel:' + String(tel || '').replace(/[^0-9+]/g, '');
  }

  /**
   * メモのツールチップ
   * @param data
   * @param key
   * @returns
   */
  noteTooltip(data, key) {
    if (data && data[key]) {
      return data[key].note
    }
    return ''
  }

  /**
   * ローカルストレージ取得
   */
  getLocalStarge() {
    this.filterName =
      localStorage.getItem('search_staffs_name') != null ? localStorage.getItem('search_staffs_name') : '';
    this.filterNameKana =
      localStorage.getItem('search_staffs_nameKana') != null ? localStorage.getItem('search_staffs_nameKana') : '';
    this.filterTel =
      localStorage.getItem('search_staffs_tel') != null ? localStorage.getItem('search_staffs_tel') : '';
    this.filterSiteName =
      localStorage.getItem('search_site_name') != null ? localStorage.getItem('search_site_name') : '';
    this.filterStaffCd =
      Number(localStorage.getItem('filterStaffCd')) ? localStorage.getItem('filterStaffCd') : null;
  }

  /**
   * ローカルストレージにセット
   */
  setLocalStarge() {
    localStorage.setItem('search_staffs_name', this.filterName);
    localStorage.setItem('search_staffs_nameKana', this.filterNameKana);
    localStorage.setItem('search_staffs_tel', this.filterTel);
    localStorage.setItem('search_site_name', this.filterSiteName);
    localStorage.setItem('filterStaffCd', this.filterStaffCd);
  }

  /**
   * ちらつき防止、DOM再利用
   * @param day
   * @returns
   */
  trackByDay(day: any): string {
    return day.day;
  }

  /**
   * ちらつき防止、DOM再利用
   * @param row
   * @returns
   */
  trackByList(row: any): string {
    return row.sequenceNumber + row.cdSite + row.cdContract
  }

  // ------------------------------------------------------------
  // ダイアログ
  // ------------------------------------------------------------

  /**
   * 清掃員名クリックイベント
   */
  staffDetailDialogOpen(event: any) {
    if (event.staffDailyCleaning != '-1') {
      this.dialog.open(StaffDetailDialogComponent, {
        maxWidth: '95vw',
        data: {
          data: event
        }
      });
    }
  }

  /**
   * 要確認データダイアログ
   */
  dataConfirmDialogOpen() {
    this.dialog.open(DataConfirmDialogComponent, {
      maxWidth: '95vw'
    });
  }

  /**
   * 休み登録ダイアログ
   * @param row 対象行
   * @param day 対象日
   */
  openHolidayDialog(row: object, day: string) {
    const dialogRef = this.dialog.open(HolidayDialogComponent, {
      maxWidth: '95vw',
      data: {
        ...row,
        day
      }
    });
    // 保存処理をしていたら親画面再取得
    dialogRef.afterClosed().subscribe(reload => {
      if (reload) {
        this.getOperations();
      }
    });
  }

  /**
   * 代勤ダイアログ
   * @param row 対象行
   * @param day 対象日
   */
  openOperationDialog(row: object, day: string) {
    const dialogRef = this.dialog.open(OperationDialogComponent, {
      maxWidth: '95vw',
      data: {
        ...row,
        day
      }
    });
    // 保存処理をしていたら親画面再取得
    dialogRef.afterClosed().subscribe(reload => {
      if (reload) {
        this.getOperations();
      }
    });
  }

  /**
   * 振替ダイアログ
   * @param row 対象行
   * @param day 対象日
   */
  openExchangeDialog(row: object, day: string) {
    const dialogRef = this.dialog.open(ExchangeDialogComponent, {
      maxWidth: '95vw',
      data: {
        ...row,
        day
      }
    });
    // 保存処理をしていたら親画面再取得
    dialogRef.afterClosed().subscribe(reload => {
      if (reload) {
        this.getOperations();
      }
    });
  }

  /**
   * 振替指定日編集ダイアログ
   * @param row 対象行
   * @param day 対象日
   */
  openExchangeEditDialog(row: object, day: string) {
    const dialogRef = this.dialog.open(ExchangeEditDialogComponent, {
      maxWidth: '95vw',
      data: {
        ...row,
        day
      }
    });
    // 保存処理をしていたら親画面再取得
    dialogRef.afterClosed().subscribe(reload => {
      if (reload) {
        this.getOperations();
      }
    });
  }

  /**
   * スポット登録ダイアログ
   * @param row 対象行
   * @param day 対象日
   */
  openSpotDialog(row: object, day: string) {
    const dialogRef = this.dialog.open(OperationDialogComponent, {
      maxWidth: '95vw',
      data: {
        ...row,
        day,
        spot: true
      }
    });
    // 保存処理をしていたら親画面再取得
    dialogRef.afterClosed().subscribe(reload => {
      if (reload) {
        this.getOperations();
      }
    });
  }

}
